import { ComponentType } from "react";
import { Navigate } from "react-router-dom";

import useStore from "@/store/zustandStore";

const withAuth = <P extends object>(
  Component: ComponentType<P>,
  redirectPath: string
) => {
  const WrappedComponent: React.FC<P> = (props) => {
    const auth = useStore((state) => state.authentication);

    if (!auth) {
      return <Navigate to={redirectPath} replace />;
    }

    return <Component {...props} />;
  };

  return WrappedComponent;
};

export default withAuth;
